export default "__VITE_ASSET__zHnxbFr39M2oIH5$GIPB1w__"